import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'
import MyInput from '../../../components/forms/input'
import MyTextArea from '../../../components/forms/textArea'
import MyOrganizationCategorySelect from '../../../components/select/organizationCategorySelect'
import MyImageUpload from '../../../components/forms/imageUpload'

const EditAlumniOrganization = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})

  useEffect(() => {
    axios.post('/p/alumni/organization/detail/get', {
      merchant_oid: merchantOid,
      organization_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormValue(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleOk = () => {
    setErrorMsg({})
    if (!formValue.name) {
      setErrorMsg({nameEmpty: '名称不能为空'})
      return false
    }

    axios.post('/p/alumni/organization/edit', { 
      merchant_oid: merchantOid,
      organization_oid: props.data.oid,
      category_oid: formValue.category_oid,
      name: formValue.name,
      icon_url: formValue.icon_url,
      sort: Number(formValue.sort),
      description: formValue.description
    })
      .then(function (response) {
        if (response.errcode === 0) {
          handleCancel()
          props.getOrganizationList()
          message.success('修改成功！')
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleCancel = () => {
    setErrorMsg({})
    props.isCancel()
  }

  return (
    <Modal 
      title='编辑组织'
      destroyOnClose={true}
      width='760px'
      open={props.isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText="取消"
      okText="保存">

      <MyImageUpload 
        id="icon_url"
        label='图标'
        value={formValue.icon_url}
        setValue={setFormValue}
      />

      <MyInput
        id="name"
        required
        autoFocus
        maxLength={64}
        label='名称'
        placeholder='请输入名称'
        value={formValue.name}
        onChange={setFormValue}
        errorMsg={errorMsg.nameEmpty}
      />

      <MyTextArea
        id="description"
        label='介绍'
        minRows={3}
        placeholder='请输入组织介绍'
        value={formValue.description}
        onChange={setFormValue}
      />

      <MyOrganizationCategorySelect
        id='category_oid'
        label='选择分类'
        value={formValue.category_oid}
        onChange={setFormValue}
        errorMsg={errorMsg.categoryEmpty}
      />

      <MyInput
        type='number'
        id="sort"
        label='排序'
        value={formValue.sort}
        onChange={setFormValue}
        styles={{ width: '60px' }}
        min={0}
        max={1000}
      />
    </Modal>
  )
}
export default EditAlumniOrganization
